export const WUP_TIMEOUT = 60000
export const NORMAL_TIMEOUT = 5000
export const SUP_HOST = 'hyext.msstatic.com'
export const SUP_INNER_HOST = 'hyext.cdn.huya.com'
export const MAX_TOAST_LENGTH = 30